import { Divider, Stack, Typography, useTheme } from "@mui/material";
import { FileText } from "lucide-react";
import { useParams } from "react-router-dom";
import { useDocumentListQuery } from "web_myplann/Api/Document/useDocumentListQuery";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { DocumentItem } from "web_myplann/Portfolio/Components/Document/DocumentItem";
import { MyPlannLayout } from "web_myplann/Shared/Header/MyPlannLayout";
import NavigationHeader from "web_myplann/Shared/Header/NavigationHeader";

export const FolderDetailPage: React.FunctionComponent = (_) => {
	const { tag } = useParams();
	const theme = useTheme();
	const { t } = useResource();
	const { data } = useDocumentListQuery(tag);

	return (
		<MyPlannLayout
			disableContentPadding
			topBar={
				<NavigationHeader
					title={tag ?? ""}
					disableBottomPadding
					defaultRoute={Routing.Portfolio.PortfolioList}
				/>
			}
		>
			{data?.documents?.length === 0 ? (
				<Stack
					alignItems="center"
					justifyContent="center"
					height="85vh"
					gap={1}
				>
					<FileText size={100} />
					<Typography variant="deprecatedH3">
						{t(Resources.DocumentDetail.noDocuments)}
					</Typography>
				</Stack>
			) : (
				data?.documents?.map((item) => (
					<Stack key={item.id}>
						<DocumentItem item={item} activeTag={tag} />
						<Divider
							sx={{
								borderWidth: 1,
								borderColor: theme.palette.deprecated.grey[100],
							}}
						/>
					</Stack>
				))
			)}
		</MyPlannLayout>
	);
};
